import {useState, useEffect} from 'react'
import cn from 'clsx'
import commonStyles from '../styles.module.scss'
import useStore from 'base/store'
import {DocumentsUpload} from 'modules/documents'
import {useMount} from 'common/hooks'
import {Box, Button} from 'common/components'
import {FileInterface} from 'common/types'
import {RequestTabFormProps} from '..'

export default function RequestDocumentsForm({
  newRequest,
  isRequestCreating,
  setNewRequest,
  setTab,
  onRequestCreate,
  onClose,
}: RequestTabFormProps) {
  const role = useStore((state) => state.role)
  const [resourceConsents, setResourceConsents] = useState<FileInterface[]>(
    newRequest.resourceConsents ?? []
  )
  const [engineeringPlanApprovals, setEngineeringPlanApprovals] = useState<
    FileInterface[]
  >(newRequest.engineeringPlanApprovals ?? [])
  const [buildingConsents, setBuildingConsents] = useState<FileInterface[]>(
    newRequest.buildingConsents ?? []
  )
  const [feasibility, setFeasibility] = useState<FileInterface[]>(
    newRequest.feasibility ?? []
  )
  const isMounted = useMount()

  useEffect(() => {
    if (!isMounted) return
    setNewRequest({
      ...newRequest,
      resourceConsents,
      buildingConsents,
      engineeringPlanApprovals,
      feasibility,
    })
    // eslint-disable-next-line
  }, [
    resourceConsents,
    buildingConsents,
    engineeringPlanApprovals,
    feasibility,
  ])

  const handleNext = () => {
    if (!newRequest.loanFormSubmit) {
      return setTab('loan')
    }
    onRequestCreate()
  }

  return (
    <>
      <DocumentsUpload
        type="resourceConsents"
        files={resourceConsents}
        setFiles={setResourceConsents}
      />
      <DocumentsUpload
        type="engineeringPlanApprovals"
        files={engineeringPlanApprovals}
        setFiles={setEngineeringPlanApprovals}
      />
      <DocumentsUpload
        type="buildingConsents"
        files={buildingConsents}
        setFiles={setBuildingConsents}
      />
      <DocumentsUpload
        type="feasibility"
        files={feasibility}
        setFiles={setFeasibility}
      />
      <Box align="right">
        <Button
          className={cn(
            commonStyles.button,
            'Button_type_form',
            'Button_type_form_cancel',
          )}
          loading={isRequestCreating}
          onClick={onClose}
        >
          Cancel
        </Button>
        &nbsp;
        <Button
          className={cn(
            commonStyles.button,
            'Button_type_form',
            'Button_type_form_submit',
          )}
          htmlType="submit"
          loading={isRequestCreating}
          onClick={handleNext}
        >
          Create {role.user ? 'project' : 'request'}
        </Button>
      </Box>
    </>
  )
}
